import {FormattedMessage} from 'react-intl';
import {Heating} from '.cache/__types__';

export const translations = {
    [Heating.Gas]: <FormattedMessage defaultMessage="Plynové" />,
    [Heating.Electric]: <FormattedMessage defaultMessage="Elektrické" />,
    [Heating.Central]: <FormattedMessage defaultMessage="Ústřední" />,
    [Heating.Geothermal]: <FormattedMessage defaultMessage="Geotermální" />,
    [Heating.Remote]: <FormattedMessage defaultMessage="Vzdálené" />,
    [Heating.Other]: <FormattedMessage defaultMessage="Ostatní" />,
    [Heating.Undefined]: <FormattedMessage defaultMessage="Nespecifikováno" />,
};
